import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationResidenceTodoRuleApiService } from './organization-residence-todo-rule-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationResidenceTodoRuleApiService extends GeneratedOrganizationResidenceTodoRuleApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
